import React, { FC } from 'react';

import logoCabre from 'assets/images/logo_without_background_2.png';
import './index.scss';

export const LogoCabre: FC<Record<string, unknown>> = () => (<img alt="logo cabre" className="f-logo-cabre" src={logoCabre} />);
